"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var fadeinup = /*#__PURE__*/(0, _styledComponents.keyframes)(["from{opacity:0;transform:translateY(10em);visibility:hidden;}to{opacity:1;transform:none;visibility:visible;}"]);
var _default = exports["default"] = fadeinup;